import { message as antdMessage } from 'antd';
import { MessageInstance, ArgsProps, MessageType } from 'antd/lib/message';
import classnames from 'classnames';
import React from 'react';
import { rtc } from '@/models';
import Icon from '../Icon';
import './index.less';

interface Message extends MessageInstance {
  destroy: (key: number) => void;
  info: (props: NewArgsProps) => MessageType;
  success: (props: NewArgsProps) => MessageType;
  error: (props: NewArgsProps) => MessageType;
  warning: (props: NewArgsProps) => MessageType;
}
interface NewArgsProps extends Partial<ArgsProps> {
  noIcon?: boolean;
  close?: boolean;
}

const style = document.createElement('style');
document.body.appendChild(style);

const setMessageTop = (widthAlign?: boolean) => {
  const width = document?.getElementById('siderContainer')?.clientWidth!;
  if (rtc.isShareScreen) {
    if (widthAlign) {
      style.innerText = `.ant-message { top: 80px !important; left: calc(50% - ${
        width / 2
      }px); transform: translateX(-50%); }`;
    } else {
      style.innerText = '.ant-message { top: 80px !important; }';
    }
  } else {
    if (widthAlign) {
      style.innerText = `.ant-message { top: 24px !important; left: calc(50% - ${
        width / 2
      }px); transform: translateX(-50%); }`;
    } else {
      style.innerText = '.ant-message { top: 24px !important; }';
    }
  }
};

const message: Message = {} as Message;
message.info = (props: NewArgsProps) => {
  const { className: classname, noIcon, close, content, onClose, ...rest } = props;
  const widthAlign = document?.getElementById('siderContainer')?.clientWidth! > 0;
  // 右侧开启成员聊天或者转录，toast剧中
  const className = classnames('popo-meeting-message', classname, { 'no-icon': noIcon });
  const key = Math.floor(Math.random() * 10000);
  const closeHandle = () => {
    onClose && onClose();
    antdMessage.destroy(key);
  };

  const contentElement = () => {
    return (
      <div className="content-wrap">
        <span className="content">{content}</span>
        <Icon className="message-close-icon" name="icon-close_nor" size={18} onClick={closeHandle} />
      </div>
    );
  };
  const config = {
    className,
    content: close ? contentElement() : content,
    key,
    icon: <Icon name="icon-info" size={20} style={{ color: '#848790', marginRight: '12px' }} />,
    ...rest,
  };
  setMessageTop(widthAlign);
  return antdMessage.info(config);
};
message.success = (props: NewArgsProps) => {
  const { className: classname, noIcon, close, content, onClose, ...rest } = props;
  const className = classnames('popo-meeting-message', classname, { 'no-icon': noIcon });
  const key = Math.floor(Math.random() * 10000);
  const closeHandle = () => {
    onClose && onClose();
    antdMessage.destroy(key);
  };

  const contentElement = () => {
    return (
      <div className="content-wrap">
        <span className="content">{content}</span>
        <Icon className="message-close-icon" name="icon-close_nor" size={18} onClick={closeHandle} />
      </div>
    );
  };
  const config = {
    className,
    content: close ? contentElement() : content,
    key,
    ...rest,
  };
  setMessageTop();

  return antdMessage.success(config);
};
message.error = (props: NewArgsProps) => {
  const { className: classname, noIcon, close, content, onClose, ...rest } = props;
  const className = classnames('popo-meeting-message', classname, { 'no-icon': noIcon });
  const key = Math.floor(Math.random() * 10000);
  const closeHandle = () => {
    onClose && onClose();
    antdMessage.destroy(key);
  };

  const contentElement = () => {
    return (
      <div className="content-wrap">
        <span className="content">{content}</span>
        <Icon className="message-close-icon" name="icon-close_nor" size={18} onClick={closeHandle} />
      </div>
    );
  };
  const config = {
    className,
    content: close ? contentElement() : content,
    key,
    ...rest,
  };
  setMessageTop();

  return antdMessage.error(config);
};

message.warning = (props: NewArgsProps) => {
  const { className: classname, noIcon, close, content, onClose, ...rest } = props;
  const className = classnames('popo-meeting-message', classname, { 'no-icon': noIcon });
  const key = Math.floor(Math.random() * 10000);
  const closeHandle = () => {
    onClose && onClose();
    antdMessage.destroy(key);
  };

  const contentElement = () => {
    return (
      <div className="content-wrap">
        <span className="content">{content}</span>
        <Icon className="message-close-icon" name="icon-close_nor" size={18} onClick={closeHandle} />
      </div>
    );
  };
  const config = {
    className,
    content: close ? contentElement() : content,
    key,
    ...rest,
  };
  setMessageTop();

  return antdMessage.warning(config);
};
message.destroy = (key: number) => {
  return antdMessage.destroy(key);
};

export default message;
